import Swiper from 'swiper';
import { Navigation } from 'swiper/modules';

export function initTestimonialSwipers() {
    document.querySelectorAll('.testimonial-swiper').forEach((el) => {
        const root = el.closest('.panel--testimonial-carousel');
        const counter = root ? root.querySelector('.testimonial-swiper-counter') : null;
        const prev = root ? root.querySelector('.testimonial-swiper-prev') : null;
        const next = root ? root.querySelector('.testimonial-swiper-next') : null;
        const slideCount = el.querySelectorAll('.swiper-slide').length;

        if (!slideCount) {
            return;
        }

        const updateCounter = (instance) => {
            if (!counter) {
                return;
            }
            counter.textContent = `${instance.realIndex + 1} of ${slideCount}`;
        };

        new Swiper(el, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 24,
            loop: slideCount > 1,
            speed: 600,
            navigation: {
                prevEl: prev,
                nextEl: next,
            },
            on: {
                init: updateCounter,
                slideChange: updateCounter,
            },
        });
    });
}
